import React from "react";
import { Outlet, useLocation } from "react-router";
import { Link } from "react-router-dom";

import { store } from "@src/index";

import { globalActions } from "@features/global/globalSlice";

import AdvertisersTable from "@SiteManagement/Advertisers/components/AdvertisersTable";

export const loader = async () => {
    const promises = [];
    const sponsors = store.getState().global.sponsors;

    !sponsors.length &&
        promises.push(store.dispatch(globalActions.getSponsors()));

    await Promise.all(promises);

    return null;
};

const Advertisers = (): React.JSX.Element => {
    const location = useLocation();
    const isOnIndexPage = /advertisers\/?$/.test(location.pathname);

    return (
        <div className="advertisersContent">
            {isOnIndexPage && (
                <Link
                    className="btn btn-primary mb-3"
                    to="/site-management/advertisers/add"
                >
                    Add New Advertiser
                </Link>
            )}
            {isOnIndexPage ? <AdvertisersTable /> : <Outlet />}
        </div>
    );
};

export default Advertisers;
